import LineRegisterStart from "./LineRegisterStart";

export default function LineEntryPage() {
  return (
    <LineRegisterStart
      autoStart
      entrySource="lineVersion"
      description="LINEでWizMateを使い始めます"
      startButtonLabel="LINEでWizMateを使う"
      loadingMessage="LINEを開いています..."
    />
  );
}
